var _path, _circle, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M38.8 15.6c.7 4.1-2.1 8-6.2 8.9l-11.3 2.6c-.3.1-.6 0-.8-.2l-3.3-3.2c-.3-.3-.4-.9-.1-1.2 1.7-2.2 6.9-9.2 7.3-9.7 1.3-1.8 2.8-3.1 5-3.6 4.3-1 8.7 1.9 9.4 6.4zM14.1 27.4l1.4 1.3c.2.2.1.6-.2.7l-1.7.4c-.1 0-.3 0-.3-.1l-.6-.5c-.2-.1-.2-.4 0-.5l.9-1.3c.1-.1.3-.1.5 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 31,
    cy: 16.9,
    r: 3.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M3.6 33.8h9.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 24.1,
    cy: 19.5,
    r: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrection);
export default __webpack_public_path__ + "static/media/correction.71c4470464bf780949b4aab4267bb9b3.svg";
export { ForwardRef as ReactComponent };